import { UuiFlexlayout } from "@aonunited/react";
import React, { useEffect, useState } from "react";
import './ErrorPage.scss';
import { useErrorStore } from "../../store";
export var ErrorPage = function () {
    var _a, _b;
    var errorStore = useErrorStore();
    var _c = useState(window.innerHeight), currentInneHeight = _c[0], setcurrentInneHeight = _c[1];
    useEffect(function () {
        var updateSize = function () {
            var innerHeight = window.innerHeight;
            setcurrentInneHeight(innerHeight);
        };
        window.addEventListener("resize", updateSize);
        return function () {
            window.removeEventListener("resize", updateSize);
        };
    }, []);
    return (React.createElement(UuiFlexlayout, { direction: 'row', className: 'error-page-wrapper', style: { height: "".concat(currentInneHeight - 90 - 120 - 80, "px") } },
        React.createElement(UuiFlexlayout, { direction: 'column', className: 'left-pannel-error' },
            ((_a = errorStore === null || errorStore === void 0 ? void 0 : errorStore.code) === null || _a === void 0 ? void 0 : _a.toString()) === "404" && React.createElement("h2", null, "Not found !!!!"),
            ((_b = errorStore === null || errorStore === void 0 ? void 0 : errorStore.code) === null || _b === void 0 ? void 0 : _b.toString()) !== "404" && React.createElement("h2", null, "Internal Server Error!!!!")),
        React.createElement(UuiFlexlayout, { direction: 'column', className: 'right-pannel-error' }, (errorStore === null || errorStore === void 0 ? void 0 : errorStore.code) ? React.createElement("div", null, errorStore === null || errorStore === void 0 ? void 0 : errorStore.code) : React.createElement(React.Fragment, null, "500"))));
};
